/**
 * The live checklist's frames, applied to the playbook panel's Redux state.
 *
 * Two sockets send them in one shape: the checklist service on a call
 * (playbookChecklistWebSocketService) and Playbook Live training
 * (playbookLiveWebSocketService, services playbook_live/checklist.py), so the
 * panel ticks and animates the same in both. The caller's dispatch: the
 * training page applies them to its own Provider's store.
 */
import type { AppDispatch } from '../store';
import { applyLivePlaybookItems, clearLiveCheckAnimation, clearLiveNoteAnimation, LivePlaybookItem } from '../store/slices/salesPlaybookSlice';
import { LIVE_CHECK_HIGHLIGHT_MS, LIVE_NOTE_SHOWN_MS } from '../constants/salesPlaybook';

export interface LivePlaybookFrameData {
  playbookName?: string;
  role?: string;
  items?: LivePlaybookItem[];
  section?: LivePlaybookItem['section'];
  id?: string;
  checked?: boolean;
  note?: string;
  source?: 'ai' | 'human';
  justChecked?: boolean;
  justNoted?: boolean;
}

export function applyLivePlaybookFrame(dispatch: AppDispatch, type: string | undefined, data: LivePlaybookFrameData): void {
  if (!data.playbookName || !data.role) return;
  if (type === 'playbook_snapshot' && Array.isArray(data.items)) {
    dispatch(applyLivePlaybookItems({ playbookName: data.playbookName, role: data.role, items: data.items, snapshot: true }));
  } else if (type === 'playbook_item' && data.section && data.id && data.checked) {
    dispatch(applyLivePlaybookItems({
      playbookName: data.playbookName, role: data.role,
      items: [{ section: data.section, id: data.id, checked: true, note: data.note || '', source: data.source || 'ai', justChecked: data.justChecked, justNoted: data.justNoted }]
    }));
    // Two events per item: the check (green, then struck through) and the
    // customer's note (slides in on green that fades).
    const animationKey = `${data.section}|${data.id}`;
    if (data.justChecked) {
      setTimeout(() => dispatch(clearLiveCheckAnimation(animationKey)), LIVE_CHECK_HIGHLIGHT_MS);
    }
    if (data.justNoted) {
      setTimeout(() => dispatch(clearLiveNoteAnimation(animationKey)), LIVE_NOTE_SHOWN_MS);
    }
  }
}
